import React from 'react';
import { useParams } from 'react-router';

import ReviewPage from '../Review.page';
import { AppName, reviewPrefix } from '../../../util/lib';

const OpeningPage = (props) => {
  const { code } = useParams();
  const { api, legacy, review } = props;

  // TODO: should use diff copy for non thumbs button
  const textContent = <div>How was your experience with us?</div>;
  const choose = (overall) => async () => {
    let url = `/reviews/${review._id}`;
    if (AppName !== 'flytree') {
      url = `/reviews/invitations/${review._id}`;
    }
    try {
      if (!review) return;
      await api({
        url,
        method: 'put',
        responseType: 'json',
        data: {
          overall,
          partnerId: review.partnerId,
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const prefix = reviewPrefix(legacy);
  // handle ignore overall experience
  if (review) {
    const { partner } = review;
    if (partner && partner.ignoreExperience) {
      return 'loading...';
    }
  }
  // no review instance
  else {
    return 'loading...';
  }
  // INFO:
  // Render Google, FB, and external review sources for good experience
  // only use repairy form to capture bad experience as fallback
  return (
    <ReviewPage
      reviewLogo="0"
      buttonType="thumbs"
      textContent={textContent}
      onSuccess={choose('good')}
      onFallback={choose('bad')}
      successPage={`${prefix}/${code}/tree`}
      fallbackPage={`${prefix}/${code}/review-form-bad`}
    />
  );
};
export default OpeningPage;
